<template>
    <AppSection :title="params.messages.title" class="section-reviews">
        <template #header_left v-if="params.header_left">
            <div v-html="params.header_left"></div>
        </template>
        <template #header_right v-if="params.header_right">
            <a v-if="params.header_right.link" :href="params.header_right.link">{{ params.header_right.title }}</a>
        </template>
        <template #body>
            <div class="section-reviews__slider">
                <div class="">
                    <div class="section-reviews__slider-main">
                        <div class="section-reviews__slider-btns">
                            <button class="swiper-button-prev" ref="btnPrev" aria-label="previous slide">
                                <svg class="icon" width="26" height="20" viewBox="0 0 26 20"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M9.28201 18.4849L1.50383 10.7068C1.11331 10.3162 1.11331 9.68308 1.50383 9.29256C1.89436 8.90203 2.52752 8.90203 2.91804 9.29256L10.6962 17.0707C11.0867 17.4613 11.0867 18.0944 10.6962 18.4849C10.3057 18.8755 9.67253 18.8755 9.28201 18.4849Z"/>
                                    <path
                                        d="M1.50383 10.7065C1.11331 10.3159 1.11331 9.68278 1.50383 9.29225C1.89435 8.90173 2.52752 8.90173 2.91804 9.29225C3.30857 9.68278 3.30857 10.3159 2.91804 10.7065C2.52752 11.097 1.89436 11.097 1.50383 10.7065Z"/>
                                    <path
                                        d="M3.21094 8.80811L24.2109 8.80811C24.7632 8.80811 25.2109 9.25582 25.2109 9.80811C25.2109 10.3604 24.7632 10.8081 24.2109 10.8081L3.21094 10.8081C2.65865 10.8081 2.21094 10.3604 2.21094 9.80811C2.21094 9.25582 2.65865 8.80811 3.21094 8.80811Z"/>
                                    <path
                                        d="M1.50676 9.29324L9.28493 1.51506C9.67545 1.12454 10.3086 1.12454 10.6991 1.51506C11.0897 1.90559 11.0897 2.53875 10.6991 2.92927L2.92097 10.7074C2.53044 11.098 1.89728 11.098 1.50676 10.7074C1.11623 10.3169 1.11623 9.68376 1.50676 9.29324Z"/>
                                </svg>
                            </button>
                            <button class="swiper-button-next" ref="btnNext" aria-label="next slide">
                                <svg class="icon" width="26" height="20" viewBox="0 0 26 20"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M9.28201 18.4849L1.50383 10.7068C1.11331 10.3162 1.11331 9.68308 1.50383 9.29256C1.89436 8.90203 2.52752 8.90203 2.91804 9.29256L10.6962 17.0707C11.0867 17.4613 11.0867 18.0944 10.6962 18.4849C10.3057 18.8755 9.67253 18.8755 9.28201 18.4849Z"/>
                                    <path
                                        d="M1.50383 10.7065C1.11331 10.3159 1.11331 9.68278 1.50383 9.29225C1.89435 8.90173 2.52752 8.90173 2.91804 9.29225C3.30857 9.68278 3.30857 10.3159 2.91804 10.7065C2.52752 11.097 1.89436 11.097 1.50383 10.7065Z"/>
                                    <path
                                        d="M3.21094 8.80811L24.2109 8.80811C24.7632 8.80811 25.2109 9.25582 25.2109 9.80811C25.2109 10.3604 24.7632 10.8081 24.2109 10.8081L3.21094 10.8081C2.65865 10.8081 2.21094 10.3604 2.21094 9.80811C2.21094 9.25582 2.65865 8.80811 3.21094 8.80811Z"/>
                                    <path
                                        d="M1.50676 9.29324L9.28493 1.51506C9.67545 1.12454 10.3086 1.12454 10.6991 1.51506C11.0897 1.90559 11.0897 2.53875 10.6991 2.92927L2.92097 10.7074C2.53044 11.098 1.89728 11.098 1.50676 10.7074C1.11623 10.3169 1.11623 9.68376 1.50676 9.29324Z"/>
                                </svg>
                            </button>
                        </div>
                        <swiper
                            :navigation="{
                                prevEl: btnPrev,
                                nextEl: btnNext,
                            }"
                            :modules="modules"
                            :thumbs="{ swiper: thumbsSwiper }"
                            v-bind="{
                                'slides-per-view': 1,
                                'space-between': 31,
                            }"
                            @slideChange="slideChange"
                        >
                            <swiper-slide v-for="(item, i) in params.items" :key="i">
                                <story-card v-bind="item"/>
                            </swiper-slide>
                        </swiper>
                    </div>
                    <div class="section-reviews__slider-nav" v-if="nav">
                        <swiper
                            :modules="modules"
                            watch-slides-progress
                            @swiper="setThumbsSwiper"
                            v-bind="{
                                slidesPerView: 10,
                                breakpoints: {
                                    320: {
                                        slidesPerView: 3.2,
                                        spaceBetween: 10,
                                    },
                                    768: {
                                        slidesPerView: 6,
                                        spaceBetween: 10,
                                    },
                                    1024: {
                                        slidesPerView: 10,
                                        spaceBetween: 10,
                                    }
                                },
                            }"
                        >
                            <swiper-slide v-for="(item, i) in params.items" :key="i">
                                <div class="section-reviews__slider-nav-item">
                                    <div class="section-reviews__slider-nav-item-inner">
                                        <div class="section-reviews__slider-nav-item-media">
                                            <img :src="item.nav_picture" alt="">
                                        </div>
                                    </div>
                                </div>
                            </swiper-slide>
                        </swiper>
                    </div>
                </div>
            </div>
        </template>
    </AppSection>
</template>

<script>
import {ref, provide} from 'vue';
import AppSection from '../AppSection.vue'
import ReviewCard from '../cards/ReviewCard.vue'
import {Swiper, SwiperSlide} from 'swiper/vue';
import {Thumbs, Navigation, Pagination} from 'swiper';
import StoryCard from "../cards/StoryCard";

export default {
    name: 'StoriesSliderSection',
    props: {
        params: {
            type: Object,
            default: () => {
            }
        },
        nav: {
            type: Boolean,
            default: false,
        }
    },
    components: {
        StoryCard,
        AppSection,
        ReviewCard,
        Swiper,
        SwiperSlide,
    },
    setup: (props, ctx) => {
        provide('translates', props.params.messages)
        const btnPrev = ref(null)
        const btnNext = ref(null)
        const thumbsSwiper = ref(null);
        const setThumbsSwiper = (swiper) => {
            thumbsSwiper.value = swiper;
        }

        const slideChange = (swiper) => {
            swiper.activeIndex - 1 < 0
                ? thumbsSwiper.value.slideTo(swiper.activeIndex)
                : thumbsSwiper.value.slideTo(swiper.activeIndex - 1);

            setTimeout(() => {
                thumbsSwiper.value.slides.forEach((slide) =>
                    slide.classList.remove("swiper-slide-thumb-active")
                );
                thumbsSwiper.value.slides[swiper.activeIndex].classList.add("swiper-slide-thumb-active");
            }, 100);
        }

        return {
            modules: [Navigation, Pagination, Thumbs],
            thumbsSwiper,
            setThumbsSwiper,
            btnPrev,
            btnNext,
            slideChange,
        }
    },
}
</script>

<style lang="scss">
.section-reviews {
    @include mobile {
        .section__header-col-right {
            display: none;
        }
    }

    &__slider {
        &-btns {
            position: absolute;
            left: 88px;
            bottom: 55px;
            z-index: 10;
            top: unset;

            @include tablet {
                left: 32px;
                bottom: 55px;
            }
            @include mobile {
                top: auto;
                left: 24px;
                bottom: 24px;
            }

            .swiper-button {
                &-prev,
                &-next {
                    position: initial;
                    left: auto;
                    right: auto;
                    top: auto;
                    margin: 0;
                    display: inline-flex;
                }

                &-next {
                    margin-left: 20px;
                }
            }
        }

        &-main {
            position: relative;

            .swiper {
                //padding: 30px;
                //margin: -30px;

                @include tablet {
                    //padding: 30px 15px;
                    //margin: -30px -15px;
                }

                &-slide {
                    height: auto;

                    .review-card {
                        height: 100%;
                        min-height: 420px;
                        @include tablet {
                            min-height: 340px;
                        }
                    }

                    .review-card__inner {
                        box-shadow: none;
                        border: 1px solid var(--c-gray-700);
                        @include mobile {
                            padding: 24px 24px 73px 24px;
                        }
                    }

                    &-active {
                        .review-card__inner {
                            box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05), 0px 0px 40px rgba(0, 0, 0, 0.1);
                            border-color: transparent;
                        }
                    }
                }
            }
        }

        &-nav {
            margin-top: 35px;
            @include tablet {
                margin-top: 24px;
            }

            &-item {
                &-inner {
                    cursor: pointer;
                    background: #fff;
                    border-radius: var(--br-1);
                    overflow: hidden;
                    border: 1px solid var(--c-gray-700);
                    transition: all .3s ease;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: relative;
                    padding-bottom: calc(100% - 2px);
                }

                &-media {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    @include mobile {
                        padding: 16px;
                    }

                    img {
                        object-fit: contain;
                    }
                }
            }

            .swiper {
                @include tablet {
                    padding-left: 15px;
                    padding-right: 15px;
                    margin-left: -15px;
                    margin-right: -15px;
                }

                &-slide {
                    &-thumb-active {
                        .section-reviews__slider-nav-item-inner {
                            border-color: var(--c-secondary-300);
                        }
                    }
                }
            }
        }
    }
}
</style>
